import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons'
import { OrderStatusBarProps } from '../OrderStatusBar'
import TwinIcon from '../../../../../baseComponents/TwinIcon'
import { useCallback, useRef, useState } from 'react'
import './orderStatusBarDropDown.sass'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../utils/globals/dictionary'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import TwinToolTip from '../../../../../baseComponents/TwinToolTip'
import { faCheckCircle, faXmarkCircle } from '@fortawesome/pro-solid-svg-icons'
import { displayDate } from '../../../../../utils/globals/date'
import useOnClickOutside from '../../../../../utils/hooks/useOnClickOut'

interface OrderStatusBarDropDownProps extends OrderStatusBarProps {
    isAccepted?: boolean
}

const OrderStatusBarDropDown: React.FC<OrderStatusBarDropDownProps> = ({ statuses, currentOrderStatus, isCanceled, getOrderStatusBarType, isAccepted }) => {
    const { opened, setOpened, ref } = useOrderStatusBarDropDownLogic()
    const parsedStatuses = dictionaryComplexFromJsonArr(statuses)
    const statusMessage = parsedStatuses[currentOrderStatus]?.renderMessage
    const currentStatusComplete = parsedStatuses[currentOrderStatus]
    let currentStatusText = ''
    let isOldVersion = statuses[0]?.id === 6

    for (const key in statuses) {
        const element = statuses[key]
        if (element?.id === currentOrderStatus || element?.id === 6) {
            currentStatusText = element.name
        }
    }
    return (
        <div className='flex flex-auto items-center'>
            <div className={'flex flex-auto items-center bg-white py-6 px-12 gap-x-5 relative status_bar_appstyle_new1 h-33 ' + (isCanceled ? 'canceled_bar ' : '') + (isOldVersion ? 'old_version_bar' : '') + (isAccepted ? 'accepted_bar' : '')} ref={ref}>
                <div className='flex flex-auto w-1 flex-row items-center medium14'>
                    <div className={'s_b_appstyle_new1_item mr-8 rounded-full items-center ' + (currentStatusComplete?.color || 'bg-gray-97')} />
                    <span className='status_bar_main_text block twin_elipsis' data-tooltip-id={currentStatusText}>{currentStatusText}</span>
                </div>
                {!isOldVersion ? <TwinIcon icon={opened ? faChevronUp : faChevronDown} className='ml-auto cursor-pointer' onClick={() => setOpened((old) => !old)} /> : null}
                {opened && !isOldVersion ? <DropDownStatusBarList {...{ statuses, currentOrderStatus, getOrderStatusBarType, isCanceled }} /> : null}
                {statusMessage ?
                    <TwinToolTip id={currentStatusText} place='bottom'>
                        {statusMessage}
                    </TwinToolTip>
                    : null
                }
            </div>
        </div>
    )
}

const useOrderStatusBarDropDownLogic = () => {
    const [opened, setOpened] = useState<boolean>(false)
    const ref = useRef<any>(null)

    const onReset = useCallback(() => {
        setOpened(false)
    }, [setOpened])
    useOnClickOutside(ref, onReset)

    return {opened, setOpened, ref}
}

const DropDownStatusBarList: React.FC<OrderStatusBarProps> = ({ statuses, isCanceled, getOrderStatusBarType, currentOrderStatus }) => {
    const statusesLength = statuses.length
    let isCanceledBar = isCanceled || false
    const renderThis: JSX.Element[] = []
    for (const key in statuses) {
        const parsedKey = parseInt(key)
        const element = statuses[key]
        const elementNext = statuses[parsedKey + 1]
        const { type, isLast } = getOrderStatusBarType({ element, elementNext, isCanceledBar, parsedKey, currentOrderStatus, statusesLength })
        const MyItem = Components[type]
        const statusLogs = element?.renderMessage?.props?.logs
        const statusCompletedDate = statusLogs?.[statusLogs.length - 1]?.createdAt
        renderThis.push(<MyItem statusComplete={element} name={element?.name} isLast={isLast} key={key} type={type} renderMessage={element.renderMessage} logType={element?.logType} date={statusCompletedDate ? displayDate(new Date(statusCompletedDate)) : ''} />)
    }
    return (
        <div className='flex flex-col absolute bg-white px-14 z-5 w-310 rounded-xl status_bar_drop_down_items'>
            <div className='flex flex-col relative w-full gap-y-10'>
                <div className='mt-2 status_bar_display_line' />
                {renderThis}
            </div>
        </div>
    )
}

export interface DDSingleStatusItemProps {
    name: string
    isLast: boolean
    type: string
    isCanceledBar: boolean
    className?: string
    renderMessage: JSX.Element | null
    date: string
    logType: number
    statusComplete: TwinDictionary
}
interface DDSingleStatusItemParentProps extends DDSingleStatusItemProps {
    children: React.ReactNode
}

export const DDSingleStatusItem: React.FC<DDSingleStatusItemParentProps> = ({ name, renderMessage, className, children }) => {
    return (
        <div className={'flex flex-row items-center justify-between dd_single_status_item ' + (className || '') + (renderMessage ? ' cursor-default' : '')} data-tooltip-id={name}>
            {children}
            {renderMessage ?
                <TwinToolTip id={name} place='bottom'>
                    {renderMessage}
                </TwinToolTip>
                : null
            }
        </div>
    )
}

const DDSingleStatusItemActual: React.FC<DDSingleStatusItemProps> = ({ name, isLast, logType, statusComplete, ...rest }) => {
    return (
        <DDSingleStatusItem isLast={isLast} logType={logType} className='actual_status' name={name} statusComplete={statusComplete} {...rest}>
            <div className='flex items-center gap-x-5'>
                <div className={'flex items-center justify-center rounded-full bg-white z-1 w-19 h-19 ' + (statusComplete.extraClassName || '')}>
                    <TwinIcon icon={statusComplete.icon} className={'z-1 ' + statusComplete.className} />
                </div>
                <div className='medium14'>{name}</div>
            </div>
            <div className='medium12 rounded-md px-7 py-3 bg-gray-F7 text-center'>
                <TwinTrans transKey='actual2'>Actual</TwinTrans>
            </div>
        </DDSingleStatusItem>
    )
}

const DDSingleStatusItemActualLast: React.FC<DDSingleStatusItemProps> = ({ name, date, isLast, ...rest }) => {
    const isLastClassName = isLast ? 'is_last' : ''
    return (
        <DDSingleStatusItem isLast={isLast} className={'completed_status ' + isLastClassName} name={name} date={date} {...rest}>
            <div className='flex items-center gap-x-5'>
                <TwinIcon icon={faCheckCircle} className='rounded-full z-1 bg-white text-green-43 w-19 h-19' />
                <div>{name}</div>
            </div>
            {date ? <div className='regular12 rounded-md px-7 py-3 bg-gray-F7 text-center status_date_info'>{date}</div> : null }
        </DDSingleStatusItem>
    )
}

const DDSingleStatusItemFuture: React.FC<DDSingleStatusItemProps> = ({ name, type, ...rest }) => {
    return (
        <DDSingleStatusItem type={type} className='future_status' name={name} {...rest} >
            <div className='flex items-center gap-x-5'>
                <div className='flex rounded-full border border-gray-D6 bg-white z-1 w-19 h-19'>
                    <div className='drop_down_item_ball m-auto rounded-full items-center bg-gray-D6' />
                </div>
                <div className='text-gray-97'>{name}</div>
            </div>
            <div className='regular12 text-gray-97 rounded-md px-7 py-3 bg-gray-F7 text-center'>
                <TwinTrans transKey='pending2'>Pendiente</TwinTrans>
            </div>
        </DDSingleStatusItem>
    )
}

const DDSingleStatusItemCompleted: React.FC<DDSingleStatusItemProps> = ({ name, type, isLast, date, ...rest }) => {
    const isLastClassName = isLast ? 'is_last' : ''
    return (
        <DDSingleStatusItem isLast={isLast} type={type} className={'completed_status ' + isLastClassName} date={date} name={name} {...rest}>
            <div className='flex items-center gap-x-5'>
                <TwinIcon icon={faCheckCircle} className='rounded-full z-1 bg-white text-green-43 w-19 h-19' />
                <div>{name}</div>
            </div>
            {date ? <div className='regular12 rounded-md px-7 py-3 bg-gray-F7 text-center status_date_info'>{date}</div> : null}
        </DDSingleStatusItem>
    )
}

const DDSingleStatusItemCompletedCanceled: React.FC<DDSingleStatusItemProps> = ({ name, type, isLast, ...rest }) => {
    const isLastClassName = isLast ? 'is_last' : ''
    return (
        <DDSingleStatusItem isLast={isLast} type={type} className={'completed_status ' + isLastClassName} name={name} {...rest}>
            <div className='flex gap-x-5 items-center justify-center'>
                <div className='flex rounded-full bg-gray-97 z-1 ml-4 w-10 h-10'>
                    <div className='drop_down_item_ball m-auto rounded-full items-center bg-gray-D6' />
                </div>
                <div className='text-gray-97'>{name}</div>
            </div>
        </DDSingleStatusItem>
    )
}

const DDSingleStatusItemActualLastCanceled: React.FC<DDSingleStatusItemProps> = ({ name, date, ...rest }) => {
    return (
        <DDSingleStatusItem className='last_actual_status' name={name} date={date} {...rest}>
            <div className='flex items-center gap-x-5'>
                <TwinIcon icon={faXmarkCircle} className='rounded-full z-1 bg-white text-red-BA w-19 h-19' />
                <div className='medium14 text-red-BA'>{name}</div>
            </div>
            {date ? <div className='medium12 rounded-md px-7 py-3 text-red-BA text-center status_date_info'>{date}</div> : null}
        </DDSingleStatusItem>
    )
}

const Components: TwinDictionary = {
    completed_status: DDSingleStatusItemCompleted,
    actual_status: DDSingleStatusItemActual,
    future_status: DDSingleStatusItemFuture,
    last_actual_status: DDSingleStatusItemActualLast,
    canceled_completed_status: DDSingleStatusItemCompletedCanceled,
    canceled_last_actual_status: DDSingleStatusItemActualLastCanceled,
}

export default OrderStatusBarDropDown